/* eslint-disable max-len */
/**
 * Greek translations.
 */
export default {
  ACTION: {
    ACCEPT_TERMS_AND_CONTINUE: 'Αποδοχή και συνέχεια',
    APPROVE: 'Έγκριση',
    CANCEL: 'Ακύρωση',
    SAVE: 'Αποθήκευση'
  },
  ERROR: {},
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_CHECKBOX:
      'Έχω διαβάσει και αποδέχομαι τους Όρους και Προϋποθέσεις',
    ACCEPT_TERMS_DESCRIPTION:
      'Πριν αποκτήσετε πρόσβαση στην πλατφόρμα Prozis Partnership, διαβάστε και αποδεχτείτε τους Όρους και τις Προϋποθέσεις του Prozis Influencer Program.',
    ACCEPT_TERMS_NAV_TITLE: 'Όροι και Προϋποθέσεις',
    ACCEPT_TERMS_SCROLL_HINT: 'Διαβάστε μέχρι το τέλος για να συνεχίσετε.',
    DASHBOARD: 'Ταμπλό',
    ENABLE_NOTIFICATIONS_DESCRIPTION:
      'Παρατηρήσαμε ότι δεν έχετε ενεργοποιήσει τις ειδοποιήσεις. Για να συνεχίσετε να χρησιμοποιείτε την εφαρμογή, πρέπει να ενεργοποιήσετε τις ειδοποιήσεις.',
    ENABLE_NOTIFICATIONS_LINK:
      'Μπορείτε να ενεργοποιήσετε τις ειδοποιήσεις εδώ',
    ENABLE_NOTIFICATIONS_TITLE:
      'Ενεργοποιήστε τις ειδοποιήσεις για να συνεχίσετε',
    HOME: 'Αρχική σελίδα',
    INSTALL_PROZIS_APP: 'Εγκαταστήστε την εφαρμογή Prozis Store',
    INSTALL_PROZIS_APP_DESCRIPTION:
      'Εγκαταστήστε την εφαρμογή μας για κινητά για να συνεχίσετε να έχετε πρόσβαση σε όλες τις λειτουργίες.',
    INSTALL_PROZIS_APP_NAV_TITLE: 'Εγκατάσταση εφαρμογής',
    LOGOUT: 'Έξοδος',
    NOT_FOUND: 'Δεν βρέθηκε',
    OR: 'Ή',
    OR_SCAN_QR_CODE: 'Ή σαρώστε τον κωδικό QR',
    SCAN_QR_CODE: 'Σαρώστε τον κωδικό QR με την κινητή σας συσκευή',
    TODOS: 'Όλα',
    UNAUTHORIZED_DESCRIPTION_1:
      'Ενημερωθείτε από τον διευθυντή σας σχετικά με τα δικαιώματα πρόσβασης.',
    UNAUTHORIZED_DESCRIPTION_2:
      'Μετά την επαλήθευση, προσπαθήστε να συνδεθείτε ξανά.',
    UNAUTHORIZED_NAV_TITLE: 'Άρνηση πρόσβασης',
    UNAUTHORIZED_TITLE: 'Καμία πρόσβαση'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
